import React, {Component} from "react";
//import GoogleMaps from "simple-react-google-maps";
import myMarkers from "../../puntos_ventas.json"
export default class Mapa extends Component {
  render() {

    //console.log(myMarkers.extra.comercios[1]);
    var mapsItems = myMarkers.extra.comercios.map( function(item) {
      return ({ lat: Number(item.latitud), lng: Number(item.longitud), title: item.nombre })
    });
    console.log(mapsItems);

    
    return (
        <h1>Hola</h1>
    )
  }
}